import { render } from "./NewThreadList.vue?vue&type=template&id=1b7fc5af"
import script from "./NewThreadList.vue?vue&type=script&lang=js"
export * from "./NewThreadList.vue?vue&type=script&lang=js"

import "./NewThreadList.vue?vue&type=style&index=0&id=1b7fc5af&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__